import { toLabeledValues } from 'components/CIMSSelect/utils/labeledValues'
import { FieldDesignChange } from '../../../../../FDCTrackerContext/types'

/**
 * converts a concurrence level into a LabeledValueType with {@link toLabeledValues}
 *
 * @param concurrenceLevel the concurrence level of a {@link FieldDesignChange}
 */
export function toConcurrenceLevelValue(
  concurrenceLevel: FieldDesignChange['concurrenceLevel'] | undefined
) {
  if (!concurrenceLevel) return undefined
  const [value] = toLabeledValues([concurrenceLevel], {
    label: 'name',
    value: 'id',
    deleted: ({ deleted }) => deleted,
    tooltip: 'description',
  })
  return value
}
